const styles = (theme) => ({
  searchButton: {
    height: 43,
    width: 43,
    minWidth: 43,
    marginLeft: theme.spacing(1),
  },
  searchBar: {
    display: 'flex',
  },
});

export default styles;
